<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal" ref="loader"></Snackbar>
    <!-- /toasts message -->
    
    <div v-if="formSchema.loan_no" class="text-xs-left text-sm-left text-md-left" style="position: absolute; top:8px;">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-chip
          account_tree
          color="success"
          label
          outline
          v-on="on"
          >
          <v-icon color="success">account_tree</v-icon>
        &nbsp; Loan No : {{formSchema.loan_no}}</v-chip>
      </template>
      <span>Loan No : {{formSchema.loan_no}}</span>
    </v-tooltip>
  </div>

    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card-text class="pb-0">
        <v-container grid-list-md class="pb-0">
          <v-layout wrap>
            <!-- Loan Profile Re-Schedule Form -->
            <v-flex xs12 sm6 md6>
              <v-autocomplete
                label="Sub Project"
                item-text="sub_project_name"
                item-value="id"
                v-model="formSchema.sub_project_id"
                :items="SubProjectIdList"
                :rules="[v => !!v || 'Sub project is required !']"
                required
                @change="setProjectCode(formSchema.sub_project_id)"
                readonly
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
              label="Loan Period (In Month)"
              v-model="formSchema.loan_period_in_month"
              :rules="[v => !!v || 'Loan period (in month) is required !',lng11]"
              required
              type="number"
              @keyup="loanCalculate"
              readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-autocomplete
                label="Currency"
                v-model="formSchema.transaction_currency"
                :items="['BDT','USD']"
                readonly
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md6 >
              <v-text-field label="Loan Amount" v-model="formSchema.loan_amount" 
              @keyup="LoanAmount" 
              @input="LoanAmount"
              type="number"
              readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
              label="Loan Date"
              v-model="formSchema.loan_date"
              :rules="[v => !!v || 'Loan date is required !']"
              required
              readonly
              ></v-text-field>
            </v-flex>      

            <v-flex xs12 sm6 md6>
              <v-text-field label="Re Schedule No" 
              v-model="formSchema.re_schedule_no" 
              type="number"
              :rules="[lng11]"
              readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Repayment Period (In Month)"
                v-model="formSchema.repayment_period_in_month"
                type="number"
                @keyup="loanCalculate"
                :rules="[lng11]"
                @input="ChangeInstType"
                readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field label="Re Schedule Date" 
              v-model="formSchema.re_schedule_date" 
              readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>              
              <v-autocomplete
                label="Installment Type"
                item-text="installment_type"
                item-value="id"
                v-model="formSchema.installment_type_id"
                :items="InstallmentTypeIdList"
                @change="ChangeInstType"
                readonly
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field label="Reset No" v-model="formSchema.reset_no" 
              type="number"
              :rules="[lng11]"
              readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="No of Installment"
                v-model="formSchema.no_of_installment"
                readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Reset Date"
                v-model="formSchema.reset_date"
                readonly
              ></v-text-field>              
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-autocomplete
                label="Interest Type"
                v-model="formSchema.interest_type"
                :items="['Fixed','Variable']"
                readonly
              ></v-autocomplete>
            </v-flex>                   

            <v-flex xs12 sm6 md6>
              <v-text-field label="Interest Rate Reset Frequency(By Month)" v-model="formSchema.interest_by_month" 
              type="number"
              readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Sub Project Location"
                v-model="formSchema.sub_project_location"
                readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Interest Rate"
                v-model="formSchema.interest_rate"
                :rules="[v => !!v || 'Interest rate is required !',lng11]"
                required
                type="number"
                readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field label="Client Name" v-model="formSchema.client_name" readonly></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Overdue Interest Rate"
                v-model="formSchema.overdue_interest_rate"
                type="number"
                :rules="[lng11]"
                readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Down Payment"
                v-model="formSchema.down_payment"
                type="number"
                readonly
              ></v-text-field>
            </v-flex>

             <v-flex xs12 sm6 md6>
              <v-text-field label="Check Number" 
              v-model.number="formSchema.check_number"
              readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field label="Check Date" 
              v-model.number="formSchema.check_date"
              readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>              
              <v-text-field label="Agreement Date" v-model="formSchema.agreement_date" readonly></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Grace Period With Interest (In Month)"
                v-model="formSchema.sub_grace_period_in_month"
                readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Grace Period (In Month)"
                v-model="formSchema.grace_period_in_month"
                readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-autocomplete
                label="PFI Name"
                item-text="short_name"
                item-value="id"
                v-model="formSchema.pfi_info_id"
                :items="PfiInfoIdList"
                :rules="[v => !!v || 'PFI info is required !']"
                required
                readonly
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Grace Period Interest Rate"
                v-model="formSchema.grace_period_interest_rate"
                type="number"
                :rules="[lng11]"
                readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field label="Sector Name" v-model="formSchema.sector_name" readonly></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6 style="position:relative">
              <v-text-field
                style="width:75%; display: inline-block;"
                label="Sub-Project IDA amount"
                v-model="formSchema.loan_amount_ida"
                @keyup="changeLoanAmount(formSchema.loan_amount_ida,'IDA')"
                @input="changeLoanAmount(formSchema.loan_amount_ida,'IDA')"
                type="number"
                readonly
              ></v-text-field>
              <input type="text" v-model="formSchema.loan_amount_ida_percent" 
              readonly
              style="border:1px solid #ccc; width:18%; display: inline-block;">%
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field label="Sub Sector Name" v-model="formSchema.sub_sector_name" readonly></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6 style="position:relative">
              <v-text-field
                style="width:75%; display: inline-block;"
                label="Sub-Project GoB amount"
                v-model="formSchema.loan_amount_gob"
                @keyup="changeLoanAmount(formSchema.loan_amount_gob,'GoB')"  
                @input="changeLoanAmount(formSchema.loan_amount_gob,'GoB')"    
                type="number"
                readonly
              ></v-text-field>
              <input type="text" v-model="formSchema.loan_amount_gob_percent" 
              readonly
              style="border:1px solid #ccc; width:18%; display: inline-block;">%
            </v-flex>

             <v-flex xs12 sm6 md6>
              <v-text-field label="PFI Account (In BB)" 
              v-model="formSchema.pfi_account_in_bb"
              :rules="[lng30]"
              readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>              
              <v-text-field label="Commitment Charge" 
              v-model.number="formSchema.commitment_charge" 
              type="number" :rules="[lng11]"
              readonly
              ></v-text-field>
            </v-flex>            

            <v-flex xs12 sm6 md6>
              <v-text-field label="Repayment Start Date" 
              v-model.number="formSchema.repayment_start_date"
              readonly
              ></v-text-field>
            </v-flex>
            
            <v-flex xs12 sm6 md6>
              <v-autocomplete
                label="Disbursement Account IDA"
                item-text="eco_account_name"
                item-value="id"
                v-model="formSchema.disbursement_account_ida"
                :items="RePaymentAccountNoGobList"
                readonly
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-autocomplete
                label="Disbursement Account GoB"
                item-text="eco_account_name"
                item-value="id"
                v-model="formSchema.disbursement_account_gob"
                :items="RePaymentAccountNoGobList"
                readonly
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-autocomplete
                label="Repayment Account"
                item-text="eco_account_name"
                item-value="id"
                v-model="formSchema.re_payment_account_no_ida"
                :items="RePaymentAccountList"
                readonly
              ></v-autocomplete>
            </v-flex>

            <!-- <v-flex xs12 sm6 md6>
              <v-autocomplete
                label="Re Payment Account No GoB"
                item-text="eco_account_name"
                item-value="id"
                v-model="formSchema.re_payment_account_no_gob"
                :items="RePaymentAccountList"
                readonly
              ></v-autocomplete>
            </v-flex>  -->

            <v-flex xs12 sm6 md6>
              <v-textarea label="Remarks" v-model="formSchema.remarks" ></v-textarea>
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>
    </v-form>

    <v-card-actions>
      <span v-if="formSchema.total_disburs > 0" style="color:green">       
        <v-alert :value="true" type="info" >
         Repayment has already been created
      </v-alert>
      </span>
      <span v-else>
        <v-btn v-if="formSchema.id>0" color="success" @click="nextStep(3)">
          Repayment
        </v-btn>
      </span>

      <v-spacer></v-spacer>
        <v-btn v-if="!formSchema.total_disburs && saveBtn" :disabled="buttonDisable"  color="primary" @click="createReSchedule">
          Save & Next
          <v-icon>arrow_forward_ios</v-icon>
        </v-btn>
        <v-btn v-if="!formSchema.total_disburs" color="secondary" @click="close">
          Reset
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-btn color="primary" @click="nextStep(2)">
          Next
          <v-icon>arrow_forward_ios</v-icon>
        </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
let commonService = require("../../../../services/common.service");
import DatePicker from "../../../global/date_picker";

export default {

  components: {
    DatePicker
  },
  data() {
    return {
      valid: true,
      e1: 0,
      isActiveVal: 0,
      checkboxVal: 1,
      loan_id: sessionStorage.getItem("loan_id"),
      buttonDisable: false,
      saveBtn: true,
      SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },

      locationList: [
        "Dhaka",
        "Khulna",
        "Rajshahi",
        "Rangpur",
        "Sylhet",
        "Barisal"
      ],

      rules: {
        decimalOnly: value => {
          const pattern = /^\d+(\.\d)?\d*$/;
          return pattern.test(value) || "Not a valied number";
        }
      },

      loanNoObject: {
        Project_code: "",
        SectorShortName: "",
        PFI_ShortName: "",
        TotalLoanCount: 0
      },

      SubProjectIdList: [],
      PfiInfoIdList: [],
      InstallmentTypeIdList: [],
      DisbursementAccountIdaList: [],
      DisbursementAccountGobList: [],
      RePaymentAccountNoIdaList: [],
      RePaymentAccountNoGobList: [],
      RePaymentAccountList:[],

      formSchema: {
        id: 0,        
        loan_no: "",
        total_disburs:"",
        loan_date: "",
        re_schedule_no: "",
        re_schedule_date: "",
        reset_no: "",
        reset_date: "",
        sub_project_location: "",
        client_name: "",
        agreement_date: "",
        loan_amount: "",
        loan_amount_ida: "",
        loan_amount_gob: "",
        loan_amount_ida_percent:"",
        loan_amount_gob_percent:"",
        commitment_charge: 0,
        repayment_start_date: "",
        loan_period_in_month: "",
        repayment_period_in_month: "",
        no_of_installment: "",
        interest_type: "",
        interest_by_month: "",
        interest_rate: "",
        overdue_interest_rate: "",
        down_payment:"",
        check_number:"",
        check_date:"",
        grace_period_in_month: "",
        grace_period_interest_rate: "",
        sector_name: "",
        sub_sector_name: "",
        pfi_account_in_bb: "",
        transaction_currency: "",
        status: ""
      }
    };
  },

  created() {

    commonService.getAllData("get-dropdown-data-for-load-profile").then(res => {
      this.SubProjectIdList = res.SubProjectIdList;
      this.PfiInfoIdList = res.PfiInfoIdList;
      this.InstallmentTypeIdList = res.InstallmentTypeIdList;
      this.RePaymentAccountNoGobList = res.AccountInfo;
      this.RePaymentAccountList = res.RePaymentAccountList;

      let common_data = this.$store.getters.GET_COMMON_DATA;

      this.formSchema = {...common_data}
      console.log({common_data})
//1=Active, 2=execute, 3= Reset, 4=Re-Schedule, 5=Close, 6=Terminate and 7=Early Settelment

    let formSchema = this.formSchema;
    formSchema.id = 0;
    formSchema.status = 4;
    formSchema.old_loan_id = common_data.loan_id;

    // let nowInstallment_Num = (common_data.no_of_installment - common_data.old_paid_installment_number);

    formSchema.reset_no = common_data.reset_no;
    formSchema.re_schedule_no = common_data.new_re_schedule_no

    formSchema.installment_type_id = common_data.new_installment_type_id
    formSchema.no_of_installment = common_data.new_no_of_installment

    formSchema.interest_rate = common_data.new_interest_rate
    formSchema.overdue_interest_rate = common_data.overdue_amount
    formSchema.interest_by_month = common_data.new_interest_by_month

    //formSchema.sub_grace_period_in_month = common_data.sub_grace_period_in_month
    formSchema.grace_period_interest_rate = 0

    formSchema.loan_amount = this.numberFormate(common_data.loan_amount)

    //formSchema.loan_amount = this.numberFormate(common_data.old_opening_principal.opening_principal) // stop from 11/10/2020 date
    formSchema.remarks = "";

    let dividebBy = this.InstallmentTypeIdList.filter(function(a){
      return a.id == common_data.new_installment_type_id
    })[0].year_divided;

    //console.log('dividebBy == ', dividebBy);
    let period_in_month = (common_data.new_no_of_installment * dividebBy)
    formSchema.repayment_period_in_month = period_in_month

    var gracePeriod = parseInt(common_data.grace_period_in_month);

    if(common_data.interestPay_InGracePeriod == 'With Interest Payment'){
      var gracePeriod = (parseInt(common_data.grace_period_in_month) - parseInt(common_data.sub_grace_period_in_month));
      formSchema.repayment_period_in_month = parseInt(period_in_month) - parseInt(gracePeriod);
    }
    if(common_data.interestPay_InGracePeriod == 'With Interest Payment' && 
    parseInt(common_data.grace_period_in_month) == parseInt(common_data.sub_grace_period_in_month)){
      formSchema.repayment_period_in_month = parseInt(period_in_month) - parseInt(common_data.grace_period_in_month) ;
    }

    formSchema.loan_period_in_month = (parseInt(period_in_month) + parseInt(gracePeriod));
    formSchema.grace_period_in_month = parseInt(common_data.grace_period_in_month)
    formSchema.loan_date = this.changeFormateDMY(
      common_data.new_re_schedule_date
      );
    formSchema.re_schedule_date = this.changeFormateDMY(
      common_data.new_re_schedule_date
      );
    formSchema.reset_date = this.changeFormateDMY(
      common_data.new_reset_date
      );
    formSchema.agreement_date = this.changeFormateDMY(
      common_data.agreement_date
      );

    formSchema.repayment_start_date = this.changeFormateDMY(
      common_data.new_repayment_start_date
      );

    formSchema.check_date = this.changeFormateDMY(
      common_data.check_date
      );

    });

    /*if (this.loan_id) {
      this.loadData();
    }*/
  },

  methods: {                                                                                                                                        
    
    numberFormate(numBer)
    {
      if(numBer != '-')
      {
        return Number(numBer).toFixed(4);
        //return Math.round(numBer);
        //return Math.round(numBer).toLocaleString()+'.00';
      }
      else
      {
       return '0.00'; 
      }
    },

    loadData() {
     
      commonService
        .getAllDataById(this.loan_id, "loan-profile-data-by-id")
        .then(res => {
          if (res.data) {
           /*console.log('res.data', res.data);*/

            this.formSchema = res.data;

            this.$store.commit('SET_KEY_VALUE', this.formSchema.total_disburs);

            this.formSchema.loan_date = this.changeFormateDMY(
              this.formSchema.loan_date
            );
            this.formSchema.re_schedule_date = this.changeFormateDMY(
              this.formSchema.re_schedule_date
            );
            this.formSchema.reset_date = this.changeFormateDMY(
              this.formSchema.reset_date
            );
            this.formSchema.agreement_date = this.changeFormateDMY(
              this.formSchema.agreement_date
            );
            this.formSchema.repayment_start_date = this.changeFormateDMY(
              this.formSchema.repayment_start_date
            );
          }
        });
    },

    createReSchedule() {
      if (this.$refs.form.validate()) {
        // button disable for a while
        this.buttonDisable = true;
        // Data submission
        
        this.submitForm();

        // Re-enable after 3 seconds
        this.timeout = setTimeout(() => {
          this.buttonDisable = false
        }, 3000)
      }
    },

    submitForm() {
      this.$refs.loader.loaderEnabled();

      let $this = this;
      let formSchema = {...this.formSchema};

    /*  formSchema.loan_no = formSchema.loan_date = this.changeFormateYMD(
        formSchema.loan_date
      );*/

      formSchema.loan_date = this.changeFormateYMD(
        formSchema.loan_date
      );
      formSchema.re_schedule_date = this.changeFormateYMD(
        formSchema.re_schedule_date
      );
      formSchema.reset_date = this.changeFormateYMD(formSchema.reset_date);

      formSchema.agreement_date = this.changeFormateYMD(
        formSchema.agreement_date
      );

      formSchema.repayment_start_date = this.changeFormateYMD(
        formSchema.repayment_start_date
      );

      formSchema.check_date = this.changeFormateYMD(
        formSchema.check_date
      );

      formSchema.interest_rate =formSchema.interest_rate;

      let functionName = "insertFormData";

      //console.log('New Paye',key_value) from Here=====;  
       let key_value = this.$store.getters.GET_KEY_VALUE; 
        if(key_value && key_value.length > 0)
        {
          formSchema.partial_pay = key_value;
        }

      commonService[functionName](formSchema, "loan-re-schedule").then(res => {
        if (res.status == 1) {
          this.saveBtn = false;
          this.SnackbarVal.message = res.message;
          this.SnackbarVal.snackbar = true;
          this.SnackbarVal.color = "success";

          sessionStorage.setItem("loan_id", res.data.id);
          setTimeout(function() {
            $this.date_formate();            
          }, 3000);
        }
        else
        {
          this.SnackbarVal.message = res.message;
          this.SnackbarVal.snackbar = true;
          this.SnackbarVal.color = "error";
        }
      });
    },

    date_formate() {
      let formSchema = this.formSchema;

      formSchema.financing_agreement_date = this.changeFormateDMY(
        formSchema.financing_agreement_date
      );
      formSchema.administration_agreement_date = this.changeFormateDMY(
        formSchema.administration_agreement_date
      );
      formSchema.project_approval_date = this.changeFormateDMY(
        formSchema.project_approval_date
      );
      formSchema.project_start_date = this.changeFormateDMY(
        formSchema.project_start_date
      );
       formSchema.agreement_date = this.changeFormateDMY(
        formSchema.agreement_date
      );
      formSchema.project_end_date = this.changeFormateDMY(
        formSchema.project_end_date
      );
      this.nextStep(2);
    },

    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
    },

    loanCalculate() {
      let formSchema = this.formSchema;

      /*formSchema.grace_period_in_month =
        Number(formSchema.loan_period_in_month) -
        Number(formSchema.repayment_period_in_month);*/
    },

    ChangeInstType() {

      let instTypeVal = this.formSchema.installment_type_id
      if(instTypeVal>0)
      {
        let formSchema = this.formSchema;

        let dividedVal = this.InstallmentTypeIdList.filter(function (a) 
        {  
          return a.id === instTypeVal
        })[0];

        formSchema.no_of_installment =
        Number(formSchema.repayment_period_in_month) / Number(dividedVal.year_divided);
      }
      
    },

    LoanAmount(){
      this.formSchema.loan_amount_ida = 0;
      this.formSchema.loan_amount_gob = 0;
    },

    changeLoanAmount(val, forVal) {
      let formSchema = this.formSchema;

      // loan_amount_ida_percent
      // loan_amount_gob_percent

      let loanAmount = Number(formSchema.loan_amount);
      let idaAmount = Number(formSchema.loan_amount_ida);
      let gobAmount = Number(formSchema.loan_amount_gob);

      if (loanAmount < 1) {
        this.SnackbarVal.message = 'Loan amount is empty!';
        this.SnackbarVal.snackbar = true;
        this.SnackbarVal.color = "error";
        formSchema.loan_amount_ida = 0;
        formSchema.loan_amount_gob = 0;
        return 0
      }

      if((idaAmount > loanAmount) || (gobAmount > loanAmount))
      {
        this.SnackbarVal.message = 'Cross your loan amount!';
        this.SnackbarVal.snackbar = true;
        this.SnackbarVal.color = "error";
        formSchema.loan_amount_ida = 0;
        formSchema.loan_amount_gob = 0;
        return 0
      }

      if (forVal == "IDA") {
        formSchema.loan_amount_gob = (loanAmount - idaAmount);        
      }
      if (forVal == "GoB") {
        formSchema.loan_amount_ida = (loanAmount - gobAmount);        
      }

      formSchema.loan_amount_ida_percent = ((idaAmount * 100) / loanAmount).toFixed(2);
      formSchema.loan_amount_gob_percent = ((gobAmount * 100) / loanAmount).toFixed(2);
    },

    setProjectCode(subProId) {
      let formSchema = this.formSchema;
      if (subProId) {
        let proInfo = this.SubProjectIdList.filter(function(val) {
          return val.id == subProId;
        })[0];
        
        formSchema.sub_project_location = proInfo.location_name;
        formSchema.client_name = proInfo.client_name;
        formSchema.agreement_date = this.changeFormateDMY(
          proInfo.agreement_date
        );
        formSchema.sector_name = proInfo.sector_name;
        formSchema.sub_sector_name = proInfo.sub_sector_name;
      }
    },

    nextStep(stp) {
      this.$emit("emitForm1", stp);
    },

    previous() {
      this.$emit("emitForm1", 1);
    },

    close: function() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
  position: absolute !important;
  left: 37%;
}
</style>


// WEBPACK FOOTER //
// src/components/lending/loanProfile/step_forms/loanReScheduleForm.vue